export default function PageDescription() {
    return (
      <div className="max-w-6xl py-8 mx-auto px-4 md:px-0">
        <p className="font-sans text-xs font-medium tracking-widest uppercase text-[var(--primary)] mb-3">
          Live Markets
        </p>
  
        <h1
          className="font-sans text-white mb-3 font-light tracking-wide"
          style={{ fontSize: "clamp(28px, 5vw, 48px)" }}
        >
          Digital Asset{" "}
          <span className="font-semibold text-[var(--primary)]">
            Prices
          </span>
        </h1>
  
        <p className="font-sans text-sm font-light tracking-wide text-[var(--foreground-muted)]">
          Real-time pricing. Auto-refreshes every 30s.
        </p>
      </div>
    );
  }